import {
  DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP,
  DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP,
  DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP,
  DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP,
  SET_AGE_OPTIONS_FOR_DIVISONS,
  DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS,
  DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS,
  DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS,
  GET_VIRTUAL_EVENT_SCORING_METHODS,
  GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS,
  GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT,
  SET_AGE_VERIFICATION_EVENT_FOR_EVENT,
  GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT,
  DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP
} from './constants';

export const displayVirtualEventForm = virtualEventId => ({
  type: DISPLAY_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  payload: virtualEventId
});

export const setAgeVerificationDateForEvent = ageVerificationDate => ({
  type: SET_AGE_VERIFICATION_EVENT_FOR_EVENT,
  payload: ageVerificationDate
});

export const cancelVirtualEventForm = () => ({
  type: CANCEL_VIRTUAL_EVENT_FORM_FOR_TOURNAMENT_SETUP
});

export const displayVirtualEvents = virtualEvents => ({
  type: DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_SETUP,
  payload: virtualEvents
});

export const displayNewVirtualEvent = () => ({
  type: DISPLAY_NEW_VIRTUAL_EVENT_FOR_TOURNAMENT_SETUP
});

export const displayNewEvent = () => ({
  type: DISPLAY_NEW_BOWL_EVENT_FOR_TOURNAMENT_SETUP
});

export const displayEventForm = id => ({
  type: DISPLAY_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP,
  payload: id
});

export const cancelEventItemForm = () => ({
  type: CANCEL_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP
});

export const displayEvents = data => ({
  type: DISPLAY_BOWL_EVENTS_FOR_TOURNAMENT_SETUP,
  payload: data
});

export const setAgeOptions = ageOptions => ({
  type: SET_AGE_OPTIONS_FOR_DIVISONS,
  payload: ageOptions
});

export const displayVirtualEventAgeOptions = showAgeOptions => ({
  type: DISPLAY_VIRTUAL_EVENT_AGE_OPTIONS,
  payload: showAgeOptions
});

export const displayVirtualEventScoringMethodOptions = showMethodOptions => ({
  type: DISPLAY_VIRTUAL_EVENT_SCORING_METHOD_OPTIONS,
  payload: showMethodOptions
});

export const displayVirtualEventOwnedByOptions = showOwnedBy => ({
  type: DISPLAY_VIRTUAL_EVENT_OWNED_BY_OPTIONS,
  payload: showOwnedBy
});

export const getVirtualEventScoringMethods = scoringMethods => ({
  type: GET_VIRTUAL_EVENT_SCORING_METHODS,
  payload: scoringMethods
});

export const getVirtualEventOwnedByOptions = ownedByOptions => ({
  type: GET_VIRTUAL_EVENT_OWNED_BY_OPTIONS,
  payload: ownedByOptions
});

export const getHandicapAppliedToOptions = handicapAppliedOptions => ({
  type: GET_HANDICAP_APPLIED_TO_OPTIONS_FOR_VIRTUAL_EVENT,
  payload: handicapAppliedOptions
});

export const getAvailableLocationOptions = availableLocationOptions => ({
  type: GET_AVAILABLE_LOCATION_OPTIONS_FOR_EVENT,
  payload: availableLocationOptions
});

export const deleteEventItemForm = () => ({
  type: DELETE_BOWL_EVENT_FORM_FOR_TOURNAMENT_SETUP
});



// WEBPACK FOOTER //
// ./src/features/tournament/events/actionTypes.js